import template from './index.jst';
import './index.styl';
import { StatsItem } from '../../../views';
import FixturesStatsHeading from './FixturesStatsHeading';
import FixturesStatsTable from './FixturesStatsTable';
import UpcomingFixturesStatsHeading from './UpcomingFixturesStatsHeading';
import UpcomingFixturesStatsTable from './UpcomingFixturesStatsTable';

export class FixturesStats extends StatsItem {
	get template() {
		return template;
	}

	get className() {
		return 'fixtures-stats player-profile';
	}

	regions() {
		return {
			'fixtures_stats_header':          '.fixtures-stats-header',
			'fixtures_stats_table':           '.fixtures-stats-table',
			'upcoming_fixtures_stats_header': '.upcoming-fixtures-stats-header',
			'upcoming_fixtures_stats_table':  '.upcoming-fixtures-stats-table'
		};
	}

	initialize() {
		this.getRegion( 'fixtures_stats_header' ).show(
			new FixturesStatsHeading( this.options )
		);
		this.getRegion( 'fixtures_stats_table' ).show(
			new FixturesStatsTable( {
				...this.options,
				collection: this.options.fixtures
			} ) );

		this.getRegion( 'upcoming_fixtures_stats_header' ).show(
			new UpcomingFixturesStatsHeading( this.options )
		);
		this.getRegion( 'upcoming_fixtures_stats_table' ).show(
			new UpcomingFixturesStatsTable( {
				...this.options,
				collection: this.options.upcoming_fixtures
			} ) );

	}
}
export default FixturesStats;